// FIXME: It depends on an internal API of prosemirror.
// NOTE: You can find "data-pm-slice" from prosemirror-view repository with `grep`.
export const isCopiedFromProseMirror = (dom: HTMLElement) => !!dom.querySelector("[data-pm-slice]");
